export enum MandatManagerStatus {
  EN_COURS = 'En cours',
  ANNULE = 'Annulé',
  FINALISE = 'Finalisé'
}